import React from "react";
import { Box, Typography, Container, Divider } from "@mui/material";
 
const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h3" component="h1" align="center" gutterBottom>
        Privacy Policy
      </Typography>
      <Typography variant="body2" color="textSecondary" align="center" sx={{ mb: 5 }}>
        Last updated: March 1, 2025
      </Typography>
     
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          1. Introduction
        </Typography>
        <Typography paragraph>
          At Del Toro Insurance, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
        </Typography>
        <Typography paragraph>
          Please read this Privacy Policy carefully. By accessing or using our website or services, you acknowledge that you have read, understood, and agree to be bound by all the terms of this Privacy Policy.
        </Typography>
      </Box>
     
      <Divider sx={{ my: 3 }} />
     
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          2. Information We Collect
        </Typography>
        <Typography paragraph>
          <strong>Personal Information:</strong> We may collect personally identifiable information, such as your name, address, email address, phone number, date of birth, social security number, financial information, and other information relevant to providing insurance services.
        </Typography>
        <Typography paragraph>
          <strong>Non-Personal Information:</strong> We may also collect non-personal information, such as browser type, IP address, device information, and usage data about how you interact with our website.
        </Typography>
      </Box>
     
      <Divider sx={{ my: 3 }} />
     
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          3. How We Use Your Information
        </Typography>
        <Typography paragraph>
          We use the
 
 
collected information for various purposes, including:
        </Typography>
        <Box component="ul" sx={{ pl: 4 }}>
          <Box component="li">
            <Typography paragraph>
              Providing, operating, and maintaining our website and services
            </Typography>
          </Box>
          <Box component="li">
            <Typography paragraph>
              Processing insurance applications, quotes, and claims
            </Typography>
          </Box>
          <Box component="li">
            <Typography paragraph>
              Communicating with you about your policies, claims, and other services
            </Typography>
          </Box>
          <Box component="li">
            <Typography paragraph>
              Improving our website and services
            </Typography>
          </Box>
          <Box component="li">
            <Typography paragraph>
              Complying with legal obligations
            </Typography>
          </Box>
        </Box>
      </Box>
     
      <Divider sx={{ my: 3 }} />
     
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          4. Information Sharing and Disclosure
        </Typography>
        <Typography paragraph>
          We may share your information with:
        </Typography>
        <Box component="ul" sx={{ pl: 4 }}>
          <Box component="li">
            <Typography paragraph>
              Insurance carriers and underwriters to process your applications and provide coverage
            </Typography>
          </Box>
          <Box component="li">
            <Typography paragraph>
              Service providers who assist us in operating our website and conducting our business
            </Typography>
          </Box>
          <Box component="li">
            <Typography paragraph>
              Law enforcement or government agencies when required by law
            </Typography>
          </Box>
        </Box>
        <Typography paragraph>
          We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties without your consent, except as described in this Privacy Policy.
        </Typography>
      </Box>
     
      <Divider sx={{ my: 3 }} />
     
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          5. Data Security
        </Typography>
        <Typography paragraph>
          We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
        </Typography>
      </Box>
     
      <Divider sx={{ my: 3 }} />
     
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          6. Your Rights
        </Typography>
        <Typography paragraph>
          Depending on your location, you may have certain rights regarding your personal information, including:
        </Typography>
        <Box component="ul" sx={{ pl: 4 }}>
          <Box component="li">
            <Typography paragraph>
              The right to access your personal information
            </Typography>
          </Box>
          <Box component="li">
            <Typography paragraph>
              The right to correct inaccurate information
            </Typography>
          </Box>
          <Box component="li">
            <Typography paragraph>
              The right to request deletion of your information
            </Typography>
          </Box>
          <Box component="li">
            <Typography paragraph>
              The right to restrict or object to processing
            </Typography>
          </Box>
        </Box>
        <Typography paragraph>
          To exercise these rights, please contact us using the information provided in the "Contact Us" section below.
        </Typography>
      </Box>
     
      <Divider sx={{ my: 3 }} />
     
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          7. Changes to This Privacy Policy
        </Typography>
        <Typography paragraph>
          We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date at the top of this Privacy Policy.
        </Typography>
      </Box>
     
      <Divider sx={{ my: 3 }} />
     
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" component="h2" gutterBottom>
          8. Contact Us
        </Typography>
        <Typography paragraph>
          If you have any questions about this Privacy Policy, please contact us at:
        </Typography>
        <Typography paragraph>
          <strong>Del Toro Insurance</strong><br />
          123 Insurance Boulevard<br />
          Miami, FL 33101<br />
          Email: privacy@deltoro-insurance.com<br />
          Phone: (305) 722-9936
        </Typography>
      </Box>
    </Container>
  );
};
 
export default PrivacyPolicy;
 